import React from 'react';
import { StyledStaffAttendanceDataGrid } from '../styled';
import CustomDataGridToolbar from '../../common/components/CustomDataGridToolbar';
import pallet from '../../../layouts/pallet';
import { AbsentStatusWrapper } from '../../StaffAttendance/styled';
import { StaffAttendanceRowData } from '../types/StaffAttendanceTypes';
import { PaperWrapper } from '../../common/styled';

interface TableProps {
  rows: StaffAttendanceRowData[];
  loading?: boolean;
}

const StaffAttendanceTable: React.FC<TableProps> = ({
  rows,
  loading = false
}) => {
  const columns = [
    { field: 'date', headerName: 'Date', flex: 1, minWidth: 150 },
    {
      field: 'memberCode',
      headerName: 'Member Code',
      flex: 1,
      minWidth: 160
    },
    { field: 'staffName', headerName: 'Staff Name', flex: 1.5, minWidth: 180 },
    { field: 'role', headerName: 'Role', flex: 1, minWidth: 150 },
    {
      field: 'shift',
      headerName: 'Shift',
      flex: 1,
      minWidth: 150,
      valueGetter: (value: any, row: any) => row?.Shift || ''
    },

    {
      field: 'status',
      headerName: 'Status',
      flex: 1,
      minWidth: 150,
      renderCell: (params: any) => {
        const status = (params.value || '').toUpperCase();
        switch (status) {
          case 'LEAVE':
            return 'LEAVE';
          case 'ABSENT':
            return <AbsentStatusWrapper>ABSENT</AbsentStatusWrapper>;
          case 'HALF_DAY_PRESENT':
            return (
              <span style={{ color: pallet.primary }}>HALF DAY</span>
            );
          case 'PRESENT':
            return <span style={{ color: pallet.green2 }}>PRESENT</span>;
          default:
            return status || '';
        }
      }
    },
    { field: 'markedBy', headerName: 'Marked By', flex: 1, minWidth: 180 },
    { field: 'punchInTime', headerName: 'Punch In', flex: 1, minWidth: 160 },
    { field: 'punchOutTime', headerName: 'Punch Out', flex: 1, minWidth: 160 },
    {
      field: 'markedAsLate',
      headerName: 'Marked As Late',
      flex: 0.7,
      minWidth: 120,
      renderCell: (params: any) => {
        const v = params.value;
        if (v === true) return 'YES';
        if (v === false) return 'NO';
        return '';
      }
    },
    { field: 'remark', headerName: 'Remarks', flex: 1.5, minWidth: 200 }
  ];

  return (
    <PaperWrapper>
      <StyledStaffAttendanceDataGrid
        autoHeight
        disableRowSelectionOnClick
        rows={rows}
        columns={columns}
        rowHeight={48}
        showToolbar
        slots={{ toolbar: CustomDataGridToolbar }}
        slotProps={{ toolbar: { showQuickFilter: true } }}
        loading={loading}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 25 }
          }
        }}
      />
    </PaperWrapper>
  );
};

export default StaffAttendanceTable;
